module.exports = __webpack_public_path__ + "static/THNG-Hero-112255c51ea23d78bded2c0aa67e81c8.png";